import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { pathJoin } from '@asamco/utils';
import { L10nProvider, L10nTranslationLoader } from 'angular-l10n';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AppSettings } from '../configuration/appsettings';

@Injectable({
	providedIn: 'root',
})
export class CustomTranslationLoader implements L10nTranslationLoader {
	name: string;
	asset: any;
	options?: any;

	/**
	 *
	 */
	constructor(private http: HttpClient, private app: AppSettings) {}

	get(language: string, provider: L10nProvider): Observable<{ [key: string]: any }> {
		return this.http.get(pathJoin([this.app.deployUrl, provider.asset, `${language}.json`])).pipe(
			catchError(_ => {
				// Remove language setting from localstorage
				localStorage.removeItem('defaultLocale');

				// Show warning to the user
				Swal.fire({
					icon: 'info',
					text: 'unfortunately we were unable to load the preferred language file.',
				});
				return this.http.get(pathJoin([this.app.deployUrl, 'assets/i18n', `en-US.json`]));
			})
		);
	}
}
